import { render, staticRenderFns } from "./AdminTeacherSatisfactionByGroup.vue?vue&type=template&id=079988bb&scoped=true&"
import script from "./AdminTeacherSatisfactionByGroup.vue?vue&type=script&lang=js&"
export * from "./AdminTeacherSatisfactionByGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079988bb",
  null
  
)

export default component.exports